import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CmsBlockComponent } from '@base/common/components/cms-block/cms-block.component';

import { ModalComponent } from '@shared/modal/modal.component';
import { SUMMER_EDITION_LOCATIONS } from './destinations.constant';

@Component({
    selector: 'destination-loading-modal',
    templateUrl: './destination-modal.component.html',
    styleUrl: 'destination-modal.component.scss',
    imports: [ModalComponent, CmsBlockComponent, CommonModule],
    standalone: true,
})
export class DestinationModalComponent extends ModalComponent implements OnInit {
    @Input() isByou: boolean = false;
    @Input() isSummerEdition: boolean = false;
    public europeDestinationsCmsBlockId: string = 'mobiles/banniere_forfaits-mobiles_destinations_europe';

    public sortedLocations: Record<string, string> = {};
    public locationEntries: [string, string][] = [];

    ngOnInit(): void {
        if (this.isSummerEdition) {
            this.sortedLocations = SUMMER_EDITION_LOCATIONS.reduce<Record<string, string>>(
                (acc, location, currentIndex) => {
                    const firstLetter = location
                        .charAt(0)
                        .normalize('NFD') // Normalize to decompose characters with accents
                        .replace(/[\u0300-\u036f]/g, '') // Remove accents
                        .toUpperCase();

                    acc[firstLetter] ??= '';

                    acc[firstLetter] += `${location}${currentIndex === SUMMER_EDITION_LOCATIONS.length - 1 ? '' : ', '}`;

                    return acc;
                },
                {},
            );

            this.locationEntries = Object.entries(this.sortedLocations);
        }
    }
}
